export default __webpack_public_path__ + "static/media/Cup (1).76698d9f.png";